import { permissionGuard } from './permission.guard';

/** The admin area: role, user and permission management. Admins only. */
export const adminGuard = permissionGuard((p) => p.isAdmin());
